import styled, { css, keyframes } from 'styled-components';

import { getColor } from '../../../../../stylesheets/tools';

const headlineCurtain = keyframes`
  0% { transform: scaleX(1); }
  10% { transform: scaleX(0); }
  100% { transform: scaleX(0); }
`;

const headlineTranslate = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(32%); }
`;

const aboveAnimation = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(200%); }
`;
const beforeAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-50%);
  }
  
  5% {
    opacity: 1;
  }

  10% {
    opacity: 1;
    transform: translateX(200%)
  }

  80% {
    opacity: 1;
  }
  
  100% {
    opacity: 0;
    transform: translateX(300%);
  }
`;

const afterAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-300%);
  }
  
  5% {
    opacity: 1;
  }

  10% {
    opacity: 1;
    transform: translateX(-100%)
  }

  80% {
    opacity: 1;
  }
  
  100% {
    opacity: 0;
    transform: translateX(0%);
  }
`;

const questionAnimation = keyframes`
  0% {
    filter: blur(10px);
    opacity: 0;
    transform: scale(0.8);
  }
  
  10% {
    opacity: 1;
    filter: blur(0px);
  }

  40% {
    opacity: 1;
    filter: blur(0px);
    transform: scale(1);
  }
  
  100% {
    filter: blur(10px);
    opacity: 0;
    transform: scale(1.2);
  }
`;

const StyledQuestion = styled.div`
  display: inline-block;
  animation: ${questionAnimation} 16s linear forwards;
  position: relative;

  h2 {
    position: relative;
    text-transform: none;
    white-space: nowrap;
    color: ${getColor('white')};
    z-index: 2;
    animation: ${headlineTranslate} 20s linear forwards;

    &:before {
      position: absolute;
      content: '';
      background: ${getColor('black')};
      width: 100%;
      height: 100%;
      transform-origin: right center;
      animation: ${headlineCurtain} 12s linear forwards;
    }
  }

  .question__after,
  .question__before {
    position: absolute;
    top: calc(50% - 12px);
    left: 0;
    height: 24px;
    width: 50%;
    max-width: 400px;
    z-index: 1;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      ${getColor('white')} 25%,
      ${getColor('white')} 50%,
      ${getColor('white')} 75%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  .question__before {
    z-index: 3;
    filter: blur(5px);
    animation: ${beforeAnimation} 20s ease-in-out forwards;

    &:before {
      position: absolute;
      content: '';
      width: 50%;
      height: 140%;
      top: -20%;
      z-index: 1;
      filter: blur(10px);
      animation: ${aboveAnimation} 20s ease-in-out forwards;

      ${props =>
        props.$gradientColor === 'yellow' &&
        css`
          background: linear-gradient(
            33deg,
            rgba(231, 119, 47, 0) 12%,
            #e7772f 23%,
            #fdb843 39%,
            #e7f669 74%,
            rgba(255, 255, 255, 0)
          );
        `}

      ${props =>
        props.$gradientColor === 'blue' &&
        css`
          background: linear-gradient(
            33deg,
            rgba(255, 255, 255, 0) 9%,
            #6fc3f6 40%,
            #606dee 70%,
            rgba(87, 141, 240, 0) 100%
          );
        `}

      ${props =>
        props.$gradientColor === 'green' &&
        css`
          background: linear-gradient(
            28deg,
            rgba(113, 242, 237, 0) 17%,
            #71f2ed 47%,
            #14b9b2 68%,
            rgba(34, 238, 229, 0) 100%
          );
        `}
    }
  }

  .question__after {
    z-index: 1;
    filter: blur(5px);
    animation: ${afterAnimation} 20s ease-in-out forwards;
  }
`;

export default StyledQuestion;
